/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OccupationResponseDto
 */
export interface OccupationResponseDto {
    /**
     * Identity of the Occupation
     * @type {string}
     * @memberof OccupationResponseDto
     */
    occupationId: string;
    /**
     * Patient's occupation
     * @type {string}
     * @memberof OccupationResponseDto
     */
    occupation: string;
}

/**
 * Check if a given object implements the OccupationResponseDto interface.
 */
export function instanceOfOccupationResponseDto(value: object): value is OccupationResponseDto {
    if (!('occupationId' in value) || value['occupationId'] === undefined) return false;
    if (!('occupation' in value) || value['occupation'] === undefined) return false;
    return true;
}

export function OccupationResponseDtoFromJSON(json: any): OccupationResponseDto {
    return OccupationResponseDtoFromJSONTyped(json, false);
}

export function OccupationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OccupationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'occupationId': json['occupationId'],
        'occupation': json['occupation'],
    };
}

export function OccupationResponseDtoToJSON(json: any): OccupationResponseDto {
    return OccupationResponseDtoToJSONTyped(json, false);
}

export function OccupationResponseDtoToJSONTyped(value?: OccupationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'occupationId': value['occupationId'],
        'occupation': value['occupation'],
    };
}

